// Member session persisted in localStorage. Mirrors the cart store pattern.
const KEY = 'lugs_auth_v1'
const listeners = new Set()

function read() {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY) || 'null')
    return parsed && parsed.token ? parsed : null
  } catch {
    return null
  }
}

let state = read()

function commit(next) {
  state = next
  if (next) localStorage.setItem(KEY, JSON.stringify(next))
  else localStorage.removeItem(KEY)
  listeners.forEach((fn) => fn(state))
}

async function request(path, body, token) {
  const res = await fetch(`/api/auth/${path}`, {
    method: body === undefined ? 'GET' : 'POST',
    headers: {
      'content-type': 'application/json',
      ...(token ? { 'x-auth-token': token } : {}),
    },
    body: body === undefined ? undefined : JSON.stringify(body),
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(data.error || `Request failed (${res.status})`)
  return data
}

export const auth = {
  get: () => state,
  customer: () => state?.customer || null,
  token: () => state?.token || null,
  subscribe(fn) {
    listeners.add(fn)
    return () => listeners.delete(fn)
  },
  async register(email, password, name) {
    const data = await request('register', { email, password, name })
    commit(data)
    return data.customer
  },
  async login(email, password) {
    const data = await request('login', { email, password })
    commit(data)
    return data.customer
  },
  async logout() {
    const token = state?.token
    commit(null)
    if (token) await request('logout', {}, token).catch(() => {})
  },
  async refresh() {
    if (!state?.token) return null
    try {
      const data = await request('me', undefined, state.token)
      commit({ token: state.token, customer: data.customer })
      return data.customer
    } catch {
      commit(null)
      return null
    }
  },
  async saveProfile(values) {
    const data = await request('profile', values, state?.token)
    commit({ token: state.token, customer: data.customer })
    return data.customer
  },
  orders() {
    return request('orders', undefined, state?.token)
  },
}
